import { makeStyles } from 'tss-react/mui';
import { Box } from '@mui/material';
import React from 'react';
import Icon from '@ui/Icon';
import Typography from '@ui/Typography';
import TypographyLink from '@ui/TypographyLink';

const useStyles = makeStyles()(theme => ({
  notFoundContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: `calc(100vh - 464px)`,
    gap: theme.spacing(12.5),
    flexDirection: 'column',
    paddingTop: 100,
  },
  notFoundContainerContent: {
    display: 'flex',
    gap: theme.spacing(5),
    flexDirection: 'column',
    alignItems: 'center',
  },
  cta: {
    display: 'flex',
    gap: theme.spacing(0.25),
  },
  errorText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
}));

const PublicShareError = ({
  includeHelp = true,
}: {
  includeHelp?: boolean;
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.notFoundContainer}>
      <div className={classes.notFoundContainerContent}>
        <Icon type="linkBroken02" fontSize="xlarge" />
        <div className={classes.errorText}>
          <Typography variant="h1" bold>
            We could not find this project
          </Typography>
          <Box textAlign="center">
            <Typography variant="pLg" color="secondary">
              Check with the project creator — it may have been deleted, the URL
              could be
              <br />
              broken, or you may not have access.
            </Typography>
          </Box>
        </div>
      </div>
      {includeHelp && (
        <div className={classes.cta}>
          <Typography variant="pLg" color="secondary">
            Need help?
          </Typography>
          <TypographyLink
            variant="pLg"
            href={`mailto:support@wellsaidlabs.com?subject=WellSaid Studio Error Report`}
            color="primary"
            underlined
          >
            Contact support
          </TypographyLink>
        </div>
      )}
    </div>
  );
};

export default PublicShareError;
